import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { UserProvider } from "@/context/UserContext";
import { silenceConsoleInProduction } from "@/utils/silenceConsole";

// Silence log/info/debug/warn in production builds so end-users don't see
// internal diagnostic chatter in DevTools. Dev builds (`yarn start`) and
// anyone who sets `localStorage.__debugConsole = '1'` keep full logs.
silenceConsoleInProduction();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>,
);
